import React from 'react';
import ImageDropzone from './ImageDropzone';

const DropzonePage = ({ onDropHandler, imagePath }) => (
  <ImageDropzone
    inputName="thumbnailImage"
    label="Thumbnail Image"
    imagePath={imagePath}
    alt="Thumbnail"
    onImageReady={onDropHandler}
    prepareOptions={{ letterbox: true, width: 1280, height: 720 }}
  />
);

export default DropzonePage;
